<template>
  <div>
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-body px-3">
        <v-row class="elevation-1">
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              label=""
              v-model="rutCorredor"
              hint="Rut Corredor Sin Dígito"
              single-line
              persistent-hint
              clearable
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              label=""
              v-model="rutContratante"
              hint="Rut Contratante Sin Dígito"
              single-line
              persistent-hint
              clearable
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
              label=""
              v-model="mes"
              hint="Mes"
              single-line
              persistent-hint
              clearable
            ></v-select>
          </v-col>

          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              label=""
              v-model="anio"
              hint="Año"
              single-line
              persistent-hint
              clearable
              :items = "getYears()"
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              v-model="itemsPerPage"
              hint="Reg. por pág."
              :items="dataFilterPagesItems"
              label="Reg. por pág."
              persistent-hint
              return-object
              single-line
              @change="onChangeFilterPagesItems($event)"
              v-on:fetch-more="fetchMore"
            ></v-select>
          </v-col>
        </v-row>
      </div>

      <div class="card-body px-3 pt-0">
          <v-row class="elevation-1">
            <v-col class="d-md-inline-flex d-sm-flex ">
              <button
                type="button"
                @click="searching()"
                class="btn btn-contempora btn-shadow btn-lg font-weight-bold mr-2 py-3 mb-2"
              >
                Filtrar
              </button>
              <button
                @click="onexport"
                class="btn btn-contempora btn-shadow btn-lg font-weight-bold mr-2 py-3 mb-2"
              >
                <v-icon dark> mdi-file-excel </v-icon> Reporte
              </button>
              <button
                @click="GetReporteFacturacionComision"
                class="btn btn-contempora btn-shadow btn-lg font-weight-bold mr-2 py-3 mb-2"
              >
                <v-icon dark> mdi-file-excel </v-icon> Descarga Detalle
              </button>
            </v-col>
          </v-row>     
      </div>
    </div>
    <DataTableLiquidacion
      :headers="headers"
      :items="datosVisiblesTabla"
      :page.sync="pagination.page"
      :itemKey="itemKey"
      :items-per-page="pagination.page_size"
      hide-default-footer
      :pagination="pagination"
      :pages="pages"
      v-on:fetch-more="fetchMore"
      :loading="loading"
    >
    </DataTableLiquidacion>
  </div>
</template>

<script>
import { GET_ODATA_COMISIONES } from "@/core/services/store/odata.facturacionComision.module";
import DataTableLiquidacion from "@/view/content/widgets/advance-table/DataTableLiquidacion.vue";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  GET_ODATA_LIQUIDACIONES,
  GET_ODATA_LIQUIDACIONES_CORREDOR,
  GET_ALL_ODATA_LIQUIDACIONES,
} from "@/core/services/store/odata.liquidacion.module";
import { GET_REPORTE_FACTURACION_COMISION_PERIODO } from "@/core/services/store/facturacionComision.module";
import XLSX from "xlsx";
export default {
  name: "detalleFacturacion",
  components: {
    DataTableLiquidacion,
  },
  watch: {
    itemsPerPage: {
      handler() {
        ////console.log(("handler")
        this.pagination.page = 1;
        this.pagination.page_size = this.itemsPerPage;
        this.page = 1;
        this.searching();
      },
      deep: true,
    },
  },
  data() {
    return {
      anio: this.getCurrentYear(),
      mes: this.getCurrentMonth(),
      rutCorredor: null,
      rutContratante: null,
      page: 1,
      itemsPerPage: 10,
      datosFacturacion: [],
      datosVisiblesTabla: [],
      pages: 1,
      paginationStart: { page: 1, page_size: 10, totalRecords: 0, filter: "" },
      pagination: {
        page: 1,
        page_size: this.itemsPerPage,
        totalRecords: 0,
        filter: "",
      },
      itemKey: "_Id",
      filterProject: "",
      filterStage: "",
      loading: true,
      dataFilterProjectItems: [],
      dataFilterStageItems: [],
      dataFilterPagesItems: [
        { text: "10", value: 10, default: true },
        { text: "20", value: 20 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
      ],
      headers: [
        {
          text: "Nombre Contratante",
          align: "left",
          sortable: false,
          value: "facturacionComisionId",
        },
        {
          text: "Nombre Contratante",
          value: "NombreContratante",
          width: 90,
          sortable: false,
        },
        { text: "RamoFecu", value: "RamoFecu" },
        { text: "Póliza", value: "Poliza" },
        { text: "PrimaNeta", value: "PrimaNeta" },
        // { text: "PORCENTAJE", value : "porcentaje" },
        // { text: 'PrimaNeta', value: '_id', sortable: false }
      ],
    };
  },
  created() {
    this.$bus.$on("resultadoSubida", (resultado) => {
      this.initSearching(this.paginationStart);
      this.searching();
    });
    this.$bus.$on("resultadoAprobar", (resultado) => {
      this.initSearching(this.paginationStart);
      this.searching();
    });

    this.$bus.$on("actualizarTabla", (resultado) => {
      this.initSearching(this.paginationStart);
    });
  },
  mounted() {
    this.$Progress.start();
    // this.loadProjects();
    // this.datosFacturacion = response.value;
        // this.loading = false;
        this.searching()
    // this.$Progress.finish();
    // this.initSearching(this.paginationStart);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Reservas" }]);
  },
  methods: {
    log(msg){
        console.log(msg); 
    },
    getCurrentYear() {
        const date = new Date()
        return date.getFullYear()
    },
    getCurrentMonth() {
        const date = new Date()
        return date.getMonth() + 1
    },
    initSearching(
      query = { pages: 1, page_size: this.itemsPerPage, filter: "" }
    ) {
      query.filter = this.filterGrid();
    //   this.cargarComsiones(query);
    },
    searching() {
    //   this.pagination.filter = this.filterGrid();
    //   this.cargarComsiones(this.pagination);
        const filter = { 
            page: this.page, 
            page_size: this.itemsPerPage,
            filter: "", 
            rut: this.rutCorredor,
            year: this.anio,
            month: this.mes,
            codigoRol: '',
        }
        // this.log(filter)
        this.cargarComsiones(filter)
    },
    findComisiones() { 
      this.pagination.page = 1;
      this.$emit("update:page", this.pagination.page);
      this.searching();   
    },
    filterGrid() {
      let filters = [];
      let filtros = "";
      if (this.mes && this.mes !== "") {
        filters.push("Mes eq " + this.mes);
      }
      if (this.anio && this.anio !== "") {
        filters.push("Anio eq " + this.anio);
      }
      if (this.rutCorredor && this.rutCorredor !== "") {
        filters.push("RutCorredor eq " + this.rutCorredor);
        // filters.push("contains(toupper(RutCorredor),toupper('" + this.rutCorredor + "'))");
      }
      if (this.rutContratante && this.rutContratante !== "") {
        filters.push("RutContratante eq " + this.rutContratante);
        // filters.push("contains(toupper(RutCorredor),toupper('" + this.rutCorredor + "'))");
      }

      // if( this.filterStage && this.filterStage.codigoEtapa !== "" ) {
      //   filters.push("contains(toupper(Etapa),toupper('" + this.filterStage.descripcionEtapa + "'))");
      // }
      if (filters.length > 0) {
        filtros = "&$filter=" + filters.join(" AND ");
      }
      return filtros;
    },
    goToBookingsItem(item) {
      this.$router.push({
        name: "booking-view",
        params: { codigoReserva: item.codigoReserva },
      });
    },
    fetchMore(query) {
      ////console.log(("fetchMore Booking")
      this.pagination.page = query.page;
      this.pagination.page_size = query.page_size;
      this.page = query.page;
      //7//console.log((this.pagination)
    //   this.searching();
      this.datosVisiblesTabla = this.paginate(query.page - 1)
    },
    cargarComsiones(
      query = { page: 1, page_size: this.itemsPerPage, filter: "" }
    ) {
    //   this.$store.dispatch(GET_ODATA_LIQUIDACIONES, query).then((response) => {
    this.$store.dispatch(GET_ODATA_LIQUIDACIONES_CORREDOR, query).then((response) => {
        // this.pagination.totalRecords = response["@odata.count"];
        this.pagination.totalRecords = response.length
        this.pagination.page = query.page;
        this.page = query.page;
        this.pagination.page_size = query.page_size;
        this.pages = Math.ceil(this.pagination.totalRecords / query.page_size);

        // this.datosFacturacion = response.value;
        this.datosFacturacion = response;
        // console.log('this.datosFacturacion: ', this.datosFacturacion)

        this.datosVisiblesTabla = this.paginate(0)

        this.loading = false;
        this.$Progress.finish();
      });
    },
    cargarTodasLasComsiones(
      query = { page: 1, page_size: this.itemsPerPage, filter: "" }
    ) {
      this.$store
        .dispatch(GET_ALL_ODATA_LIQUIDACIONES, query)
        .then((response) => {
          this.datosFacturacionExcel = response.value;
        });
    },
    getPercent(item) {
      return Math.round(
        (item.TotalArchivosCargados / item.TotalArchivos) * 100
      );
    },
    getVariantType(item) {
      let porcentaje = this.getPercent(item);
      if (porcentaje == 100) {
        return "success";
      } else if (porcentaje >= 50) {
        return "warning";
      } else if (porcentaje > 30) {
        return "primary";
      }
      return "danger";
    },
    onChangeFilterPagesItems(event) {
      this.pagination.page = 1;
      this.page = 1;
      this.itemsPerPage = event.value;
      this.pagination.page_size = event.value;
    },
    onChangeFilterProject(event) {
      this.loadStages({ codigoProyecto: event.codigoProyecto });
    },
    // onexport() {
    //   // this.conciliacionesFiltro = this.conciliaciones.filter((conciliacion) => {
    //   //   return (
    //   //     conciliacion.id.toLowerCase().includes(this.id.toLowerCase()) == 1 &&
    //   //     conciliacion.origenMovimiento
    //   //       .toLowerCase()
    //   //       .includes(this.origenMovimiento.toLowerCase()) == 1 &&
    //   //     conciliacion.moneda
    //   //       .toLowerCase()
    //   //       .includes(this.moneda.toLowerCase()) == 1 &&
    //   //     conciliacion.estado
    //   //       .toLowerCase()
    //   //       .startsWith(this.estado.toLowerCase()) == 1 &&
    //   //     conciliacion.subEstado
    //   //       .toLowerCase()
    //   //       .startsWith(this.subEstado.toLowerCase()) == 1 &&
    //   //     conciliacion.rutPagador
    //   //       .toString()
    //   //       .startsWith(this.rutPagador.toString()) == 1 &&
    //   //     conciliacion.dvPagador
    //   //       .toLowerCase()
    //   //       .includes(this.dvPagador.toLowerCase()) == 1 &&
    //   //     conciliacion.montoPoliza
    //   //       .toString()
    //   //       .startsWith(this.montoPoliza.toString()) == 1 &&
    //   //     conciliacion.numeroPoliza
    //   //       .toString()
    //   //       .startsWith(this.numeroPoliza.toString()) == 1 &&
    //   //     conciliacion.asignado
    //   //       .toLowerCase()
    //   //       .includes(this.asignado.toLowerCase()) == 1 &&
    //   //     conciliacion.periodoConciliacion
    //   //       .toString()
    //   //       .startsWith(this.periodoConciliacion.toString()) == 1 &&
    //   //     conciliacion.anioConciliacion
    //   //       .toString()
    //   //       .startsWith(this.anioConciliacion.toString()) == 1
    //   //   );
    //   // });
    //   let query = { page: 1, page_size: this.itemsPerPage, filter: "" };
    //   let monedaFormateada = new Intl.NumberFormat("en-US", {
    //     style: "currency",
    //     currency: "USD",
    //     minimumFractionDigits: 3,
    //   });
    //   this.$store
    //     .dispatch(GET_ALL_ODATA_LIQUIDACIONES, query)
    //     .then((response) => {
    //       response.value.forEach((element) => {
    //         element.ImpuestoAfecta = monedaFormateada
    //           .format(element.ImpuestoAfecta.toFixed(3))
    //           .replace("$", "")
    //           .replace(",", "")
    //           .replace(".", "");
    //         element.ImpuestoExenta = monedaFormateada
    //           .format(element.ImpuestoExenta.toFixed(3))
    //           .replace("$", "")
    //           .replace(",", "")
    //           .replace(".", "");
    //         element.ImpuestoTotal = monedaFormateada
    //           .format(element.ImpuestoTotal.toFixed(3))
    //           .replace("$", "")
    //           .replace(",", "")
    //           .replace(".", "");
    //         element.MontoComisionAfecta = monedaFormateada
    //           .format(element.MontoComisionAfecta.toFixed(3))
    //           .replace("$", "")
    //           .replace(".", ",");
    //         element.MontoComisionExenta = monedaFormateada
    //           .format(element.MontoComisionExenta.toFixed(3))
    //           .replace("$", "")
    //           .replace(".", ",");
    //         element.MontoAfectaUF = element.MontoAfectaUF.toFixed(5)
    //           .replace("$", "")
    //           .replace(".", ",");
    //         element.MontoExentaUF = element.MontoExentaUF.toFixed(5)
    //           .replace("$", "")
    //           .replace(".", ",");
    //         element.Neto = monedaFormateada
    //           .format(element.Neto.toFixed(3))
    //           .replace("$", "")
    //           .replace(",", "")
    //           .replace(".", "");
    //         element.TipoCambio = element.TipoCambio.toFixed(2)
    //           .replace("$", "")
    //           .replace(".", ",");
    //         element.TotalAfecta = monedaFormateada
    //           .format(element.TotalAfecta.toFixed(3))
    //           .replace("$", "")
    //           .replace(",", "")
    //           .replace(".", "");
    //         element.TotalExenta = monedaFormateada
    //           .format(element.TotalExenta.toFixed(3))
    //           .replace("$", "")
    //           .replace(",", "")
    //           .replace(".", "");
    //         element.AfectoNeto = monedaFormateada
    //           .format(element.AfectoNeto.toFixed(3))
    //           .replace("$", "")
    //           .replace(",", "")
    //           .replace(".", "");
    //         element.ExentoNeto = monedaFormateada
    //           .format(element.ExentoNeto.toFixed(3))
    //           .replace("$", "")
    //           .replace(",", "")
    //           .replace(".", "");
    //         element.TotalGirar = monedaFormateada
    //           .format(element.TotalGirar.toFixed(3))
    //           .replace("$", "")
    //           .replace(",", "")
    //           .replace(".", "");
    //       });
    //       const archivo =
    //         "DetalleFacturación_" + new Date().toISOString().substr(0, 10);
    //       var conciliaciones = [];
    //       conciliaciones = XLSX.utils.json_to_sheet(response.value);
    //       // if (this.conciliacionesFiltro.length > 0) {
    //       //   conciliaciones = XLSX.utils.json_to_sheet(this.conciliacionesFiltro);
    //       // } else {
    //       //   conciliaciones = XLSX.utils.json_to_sheet(this.conciliaciones);
    //       // }
    //       var libro = XLSX.utils.book_new();
    //       XLSX.utils.book_append_sheet(
    //         libro,
    //         conciliaciones,
    //         "DetallesConciliaciones"
    //       );
    //       XLSX.writeFile(libro, `${archivo}.xlsx`);
    //     });
    // },
        onexport() { 

     // let query = { page: 1, page_size: this.itemsPerPage, filter: "" };
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 3,
      });
      
      let query = { pages: 1, filter: "" }
      query.filter = this.filterGrid();  

      let  pagination2 = {
        page: 1,
        page_size: 100,
        totalRecords: 0,
        filter: "",
      }
      pagination2.filter = this.filterGrid();
      //this.cargarComsiones(this.pagination);

      this.$store
        .dispatch(GET_ODATA_COMISIONES,pagination2)
        .then((response) => {
          // response.value.forEach((element) => {
          //   element.ImpuestoAfecta = monedaFormateada
          //     .format(element.ImpuestoAfecta.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.ImpuestoExenta = monedaFormateada
          //     .format(element.ImpuestoExenta.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.ImpuestoTotal = monedaFormateada
          //     .format(element.ImpuestoTotal.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.MontoComisionAfecta = monedaFormateada
          //     .format(element.MontoComisionAfecta.toFixed(3))
          //     .replace("$", "")
          //     .replace(".", ",");
          //   element.MontoComisionExenta = monedaFormateada
          //     .format(element.MontoComisionExenta.toFixed(3))
          //     .replace("$", "")
          //     .replace(".", ",");
          //   element.MontoAfectaUF = element.MontoAfectaUF.toFixed(5)
          //     .replace("$", "")
          //     .replace(".", ",");
          //   element.MontoExentaUF = element.MontoExentaUF.toFixed(5)
          //     .replace("$", "")
          //     .replace(".", ",");
          //   element.Neto = monedaFormateada
          //     .format(element.Neto.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.TipoCambio = element.TipoCambio.toFixed(2)
          //     .replace("$", "")
          //     .replace(".", ",");
          //   element.TotalAfecta = monedaFormateada
          //     .format(element.TotalAfecta.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.TotalExenta = monedaFormateada
          //     .format(element.TotalExenta.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.AfectoNeto = monedaFormateada
          //     .format(element.AfectoNeto.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.ExentoNeto = monedaFormateada
          //     .format(element.ExentoNeto.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   // element.TotalGirar = monedaFormateada
          //   //   .format(element.TotalGirar.toFixed(3))
          //   //   .replace("$", "")
          //   //   .replace(",", "")
          //   //   .replace(".", "");
          // });

          let datos = []
          response.value.forEach((element) => {
              let unDato =   { 
                Mes: element.Mes, 
                Anio: element.Anio, 
                RutCorredor: element.RutCorredor, 
                DvCorredor : element.RutCorredorDv, 
                NombreCorredor : element.NombreCorredor, 
                Sucursal :element.Sucursal, 
                RutContratante: element.RutContratante,
                NombreContratante : element.NombreContratante,
                Ramo: element.Ramo,
                Poliza : element.Poliza,
                Endoso : element.Endoso,
                Moneda : element.Moneda,
                Prima : element.PrimaNeta,
                PorcentajeComision : element.PorcentajeComision,
                TipoComision : element.TipoComision
                 };
              datos.push(unDato);
          });

          let Heading = [['Mes', 'Anio', 'Rut Corredor', 'Dv Corredor','NombreCorredor','Sucursal','Rut Contratante','Nombre Contratante', 'Ramo','Poliza','Endoso','Moneda','Prima','% Comision','Tipo Comision' ]];

          const archivo =
            "DetalleComisiones_" + new Date().toISOString().substr(0, 10);
          // var conciliaciones = [];
          // conciliaciones = XLSX.utils.json_to_sheet(response.value);    

          const ws = XLSX.utils.json_to_sheet([]);

          // if (this.conciliacionesFiltro.length > 0) {
          //   conciliaciones = XLSX.utils.json_to_sheet(this.conciliacionesFiltro);
          // } else {
          //   conciliaciones = XLSX.utils.json_to_sheet(this.conciliaciones);
          // }
          var libro = XLSX.utils.book_new();
           let  ws2 = XLSX.utils.json_to_sheet( datos, { origin: 'A2', skipHeader: true });
          XLSX.utils.sheet_add_aoa(ws2, Heading);
          XLSX.utils.sheet_add_json(libro, datos, { origin: 'A2', skipHeader: true })

          XLSX.utils.book_append_sheet(
            libro,
            ws2,
            "DetalleComiisones"
          );

          // XLSX.utils.book_append_sheet(
          //   libro,
          //   conciliaciones,
          //   "DetalleComiisones"
          // );
          XLSX.writeFile(libro, `${archivo}.xlsx`);
        })
        .catch((error) => {
          this.makeToast(
            false,
            "Ha currido un problema al descargar el documento",
            "Aviso",
            "danger"
          );
        });
    },
    makeToast(append = false, texto, titulo, variant) {
      this.$bvToast.toast(texto, {
        title: titulo,
        autoHideDelay: 5000,
        variant: variant,
        toaster: "b-toaster-top-right",
        appendToast: append,
      });
    },
        getYears()
    {
      const d = new Date();
      let year = d.getFullYear();
      let years = [year]

      for(var i = 1 ; i < 5 ; i++)
      {
        years.push(year-i)
      }

       return years
    },
    getMonths()
    {

      return  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        
    },
    GetReporteFacturacionComision() {
      //Validamos los filtro
      if (this.mes == null || this.anio == null) {
        this.makeToast(
          false,
          "Favor indicar mes y año para descargar el reporte.",
          "Aviso",
          "warning"
        );
        return;
      }
      let query = { mes: this.mes, anio: this.anio };
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 3,
      });
      this.$store
        .dispatch(GET_REPORTE_FACTURACION_COMISION_PERIODO, query)
        .then((response) => {
          response.forEach((element) => {
            // element.ImpuestoAfecta = monedaFormateada
            //   .format(element.ImpuestoAfecta.toFixed(3))
            //   .replace("$", "")
            //   .replace(",", "")
            //   .replace(".", "");
            delete element.facturacionComisionId;
            delete element.statusCode;
          });
          const archivo =
            "ConciliaciónFacturación_" + new Date().toISOString().substr(0, 10);
          var conciliaciones = [];
          conciliaciones = XLSX.utils.json_to_sheet(response);
          var libro = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(
            libro,
            conciliaciones,
            "DetallesConciliaciones"
          );
          XLSX.writeFile(libro, `${archivo}.xlsx`);
          this.makeToast(
            false,
            "Reporte descargado correctamente.",
            "Aviso",
            "success"
          );
        });
    },
    paginate(page_number) {
        const page_size = this.itemsPerPage
        return this.datosFacturacion.slice(page_number * page_size, page_number * page_size + page_size)
    },
  },
};
</script>
